('use strict');
import 'vendor/jquery.isOnScreen';

import Domain from 'helpers/Domain'; // ~/src/web-package-coreui/src/js/helpers/Domain.js

let track = null;

export class Tracking {
    static scrollIsMonitored = false;
    static scrollInterval = null;
    static totalNumberCarousels = 1; // set counter =1 for brandCarousel
    static resizing = false;

    constructor() {
        this.allWrappers = [];
        this.payload = [];
        this.metadata = {};
        this.scrollTimer = null;

        let body = document.body;
        if (body.hasAttribute('data-num-carousels')) {
            this.totalNumCarousels = parseInt(body.getAttribute('data-num-carousels'));
        }
        this.carouselCounter = 0;
    }

    static addNumCarousels(numCarousels) {
        Tracking.totalNumberCarousels += numCarousels;
    }

    static removeNumCarousels(numCarousels) {
        Tracking.totalNumberCarousels -= numCarousels;
    }

    addPayLoad(carousel) {
        this.payload.push(carousel);
    }

    addWrapper(wrapper) {
        this.allWrappers.push(wrapper);
    }

    buildPayObject(payObject) {
        return {
            metadata: this.buildMetaData(),
            payload: payObject,
        };
    }

    buildMetaData() {
        return {
            country: CBS.Registry.region.property.toString(),
            device_type: this.deviceType(),
            env: CBS.Host == 'https://www.paramountplus.com' ? 'prod' : 'dev',
            optimizelyExp: CBS.Tracking.utag_data.optimizelyExp,
            page: CBS.Tracking.utag_data.pageType,
            platform: CBS.Registry.brandPlatformID.toString(),
            profile_id: CBS.Registry?.user?.profile_reference_id?.toString() ?? '',
            profile_type: CBS.Registry?.user?.profile_type?.toString() ?? '',
            site: 'cbs',
            user_id: CBS.Registry?.user?.id?.toString() ?? '',
            version: CBS.Registry?.bn ?? '',
            view_guid: CBS.Tracking.utag_data.pageViewGuid,
        };
    }

    enableAndResetDisplayTrackingInterval() {
        if (!Tracking.scrollIsMonitored) {
            Tracking.scrollIsMonitored = true; // prevents more than one scroll listener from being added
            window.addEventListener('scroll', () => {
                if (Tracking.resizing) return;
                this.afterScrollStops(() => {
                    this.trackVisibleWrappers();
                }, 1000);
            });
        }
    }

    afterScrollStops(callback, waitTimeInMS) {
        let pageYOffset = window.pageYOffset;
        if (Tracking.scrollInterval === null) {
            // prevents additional scrolling from creating additional intervals
            Tracking.scrollInterval = setInterval(() => {
                if (pageYOffset === window.pageYOffset) {
                    clearInterval(Tracking.scrollInterval);
                    callback();
                    Tracking.scrollInterval = null;
                } else {
                    pageYOffset = window.pageYOffset;
                }
            }, waitTimeInMS);
        }
    }

    getVisibleWrappers() {
        return this.allWrappers
            .filter((element) => element.isOnScreen(0.2, 0.2))
            .map((element) => this.getPayloadByDisplayID(element.data('displayid')))
            .filter((payload) => typeof payload !== 'undefined');
    }

    trackVisibleWrappers() {
        const payloads = this.getVisibleWrappers();
        this.trackWrappers(payloads);
    }

    trackWrappers(payloads) {
        payloads = payloads.filter((payload) => payload.content.length > 0);
        if (payloads.length > 0)
            this.trackObject(
                this.getFathomDisplayUrl(),
                this.buildPayObject(this.sortPayLoads(payloads)),
            );
    }

    getAllWrappers() {
        return this.allWrappers;
    }

    getFathomDisplayUrl() {
        return `${CBS.Registry.fathomHost}/display`;
    }

    getFathomClickUrl() {
        return `${CBS.Registry.fathomHost}/take`;
    }

    getPayloadByDisplayID(id) {
        return this.payload.find((obj) => obj.display_id === id);
    }

    getPayLoadByCarouselID(id) {
        return this.payload.find((obj) => obj.carousel_id === id);
    }

    getPayload() {
        return this.payload;
    }

    sortPayLoads(payloads) {
        return payloads.sort((a, b) => {
            return a.position - b.position;
        });
    }

    trackObject(url, obj) {
        let localFetchTracking = () => this.fetchTracking(url, obj);
        let urlTrackPack = [this.getFathomDisplayUrl(), this.getFathomClickUrl()];
        if (!this.suppressTracking())
            if (urlTrackPack.includes(url))
                cbsoptanon.cmd.push(function (cmp) {
                    cmp.ot.performanceAllowed(function (allowed) {
                        if (allowed) localFetchTracking();
                    });
                });
            else localFetchTracking();
    }

    fetchTracking(url, obj) {
        fetch(url, {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(this.reindexPosition(obj)),
        });
    }

    deviceType() {
        if (Domain.isInternational()) return CBS.Registry.platform.current;
        if (CBS.Tracking.utag_data.deviceType == 'desktop')
            return $('body').attr('touch-enabled') == 'true' ? 'tablet_web' : 'desktop_web';
        else if (CBS.Tracking.utag_data.deviceType == 'mobile') return 'mobile_web';
        return '';
    }

    suppressTracking() {
        return (
            CBS.Registry.user.profile_type == 'YOUNGER_KIDS' ||
            CBS.Registry.user.profile_type == 'KIDS' ||
            window.location.href.includes('user-profile')
        );
    }

    reindexPosition(obj) {
        if (Domain.isInternational()) return obj;
        let result = JSON.parse(JSON.stringify(obj));
        // There is a bug that is sending the first 2 grids/carousels at position 0
        // if (result?.payload)
        //     for (let key in result.payload)
        //         if (result.payload[key]?.position)
        //             result.payload[key].position = result.payload[key].position - 1;
        return result;
    }
}

export default class FathomTracking {
    static needToDoInitialTracking = true;
    static resizeTimeout = null;

    constructor(wrapper, swiper) {
        this.wrapper = wrapper;
        this.swiper = swiper;
        this.previouslyTrackedContent = new Set();
        if (track === null) {
            track = new Tracking();
            track.buildMetaData();
            // It may cause a twice call if the page has an scroll when it loads
            track.enableAndResetDisplayTrackingInterval();
        }

        const payload = this.buildPayLoad();
        if (!payload || payload.content === undefined) {
            return;
        }
        track.addWrapper(wrapper);
        track.addPayLoad(payload);

        // Track initial carousels
        if (FathomTracking.needToDoInitialTracking) {
            FathomTracking.needToDoInitialTracking = false;
            setTimeout(() => {
                track.trackVisibleWrappers();
            }, 3000);
        }
    }

    buildPayLoad() {
        const container = this.wrapper.parents('.js-le-carousel');
        if (!container) {
            return null;
        }
        const carouselId = container.data('carouselid');
        if (!container.data('displayid') || !container.data('recoid') || !container.data('title')) {
            return null;
        }
        this.display_id = container.data('displayid').toString();
        const videoBoxContainer = this.wrapper.children('.video-carousel-box');
        let pvrModel = videoBoxContainer.data('pvrmodel');

        const payload = {
            reco_id: container.data('recoid').toString(),
            display_id: this.display_id,
            display_name: container.data('title').toString(),
            position: container.data('position'),
            rank_model: container.data('rankmodel')?.toString(),
            pvr_model: pvrModel?.toString() ?? '',
            content: this.buildContent(),
        };

        if (carouselId) {
            payload.carousel_id = carouselId;
        }

        return payload;
    }

    buildContent() {
        if (this.swiper.slides.length) {
            let content = [];
            for (const slide in this.swiper.slides) {
                let s = this.swiper.slides[slide];
                if (s && typeof s === 'object') {
                    let $s = $(s);
                    let $link = $s.find('a.link');
                    if ($s.hasClass('swiper-slide-visible') && $link.length) {
                        let dataFathom = $link.data('fathom')?.split('|');
                        let contentId = dataFathom[0]?.toString() ?? '';
                        content.push({
                            content_id: contentId,
                            content_title: dataFathom[5].toString(),
                            content_type: dataFathom[3].toString(),
                            position: parseInt(dataFathom[2]),
                        });
                        this.previouslyTrackedContent.add(contentId);
                        this.setPayloadClick(
                            $s,
                            this.display_id,
                            contentId,
                            dataFathom[5]?.toString(),
                        );
                    }
                } else {
                    break;
                }
            }
            return content;
        }
    }

    clickEvent(event) {
        track.trackObject(track.getFathomClickUrl(), {
            display_id: event.data.displayId,
            content_id: event.data.contentId,
            content_title: event.data.contentTitle,
        });
    }

    setPayloadClick(slide, displayId, contentId, contentTitle) {
        slide
            .off('click', this.clickEvent)
            .on(
                'click',
                { displayId: displayId, contentId: contentId, contentTitle: contentTitle },
                this.clickEvent,
            );
    }

    updateFathomResizePerCarousel(position) {
        return track.getPayload().filter((x) => {
            if (parseInt(x.position) === parseInt(position)) {
                return (x.content = this.buildContent());
            }
        });
    }

    updateFathomResize() {
        if (FathomTracking.resizeTimeout !== null) clearTimeout(FathomTracking.resizeTimeout);
        FathomTracking.resizeTimeout = setTimeout(() => {
            track.trackVisibleWrappers();
        }, 300);
    }

    updateFathomTracking(position) {
        let obj = this.updateFathomResizePerCarousel(position);
        if (obj && obj.length > 0 && obj[0].content && obj[0].content.length > 0) {
            track.trackObject(track.getFathomDisplayUrl(), track.buildPayObject(obj));
        }
    }
}
